import React from 'react';
import ChatbotAdmin from '../../components/Admin/Chatbot/ChatbotAdmin';
import MappingManager from '../../components/Admin/Chatbot/MappingManager';
import { Row, Col } from 'reactstrap';

const ChatbotSettings = () => {
  // To show the Chatbot Term Mapping component, set this to true
  const showMappingManager = false;
  return (
    <div className="pt-3">
      <Row>
        <Col md={12}>
          <ChatbotAdmin />
        </Col>
      </Row>
      {/* To show the Chatbot Term Mapping component, set showMappingManager to true above */}
      {showMappingManager && (
        <Row className="mt-4">
          <Col md={12}>
            <MappingManager />
          </Col>
        </Row>
      )}
    </div>
  );
};

export default ChatbotSettings;